var map = {
	"./buffer-table/buffer-table.module": [
		"./src/app/buffer-table/buffer-table.module.ts",
		"common",
		3
	],
	"./change-buffer/change-buffer.module": [
		"./src/app/change-buffer/change-buffer.module.ts",
		"common",
		5
	],
	"./components/access-denied/access-denied.module": [
		"./src/app/components/access-denied/access-denied.module.ts",
		11
	],
	"./components/versions-not-compatible/versions-not-compatible.module": [
		"./src/app/components/versions-not-compatible/versions-not-compatible.module.ts",
		10
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		12
	],
	"./import-assortment/import-assortment.module": [
		"./src/app/import-assortment/import-assortment.module.ts",
		"common",
		6
	],
	"./item-properties/item-properties.module": [
		"./src/app/item-properties/item-properties.module.ts",
		"common",
		4
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		9
	],
	"./marketing-purchase/marketing-purchase.module": [
		"./src/app/marketing-purchase/marketing-purchase.module.ts",
		2,
		"common"
	],
	"./marketing-purchases/marketing-purchases.module": [
		"./src/app/marketing-purchases/marketing-purchases.module.ts",
		"common",
		7
	],
	"./orders/orders.module": [
		"./src/app/orders/orders.module.ts",
		0,
		"common"
	],
	"./stocks/stocks.module": [
		"./src/app/stocks/stocks.module.ts",
		1,
		"common"
	],
	"./supply-schedule/supply-schedule.module": [
		"./src/app/supply-schedule/supply-schedule.module.ts",
		"common",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main